export const CLI_COMMANDS = [
  {
    regexp: "^show api policy(?: full)?$",
    description:
      "Show the list of rate policies, both configured and dynamic (created via the RADIUS, Billing or REST API)",
  },
  {
    regexp: "^show api radius client$",
    description:
      "Show the list of RADIUS clients authorized to send RADIUS messages to the BQN server",
  },
  {
    regexp: "^show api radius parameters$",
    description: "Show the list of RADIUS configured parameters. It tells if RADIUS is enabled, the deployment mode, etc",
  },
  {
    regexp: "^show api rest client$",
    description:
      "Show the IP addresses of allowed REST clients and whether authentication is required for requests",
  },
  {
    regexp: "^show api rest server$",
    description:
      "Show the status of the REST server used to receive REST requests, such as the IP address and TCP port",
  },
  {
    regexp: "^show api rest user$",
    description:
      "Show the name and password (authentication string) of REST API users allowed to access the BQN",
  },
  {
    regexp: "^show api status(?: (?:clients|full))?$",
    description: "Show, per BQN server, if api is ready and the counters of the main information obtained, like subscribers and rate policies",
  },
  {
    regexp: "^show api subscriber(?: (?:full|[a-zA-Z0-9.:_-]+))?$",
    description:
      "Show subscribers with information obtained using the RADIUS, Billing or the REST API",
  },
  {
    regexp: "^show bta optimization(?: detail)?$",
    description:
      "Show the percentage of TCP connections being optimized and the percentage of flows generating UDR DPI records (if UDR is 0, generation is auto). Those percentages are configured using the set bta optimization command",
  },
  {
    regexp: "^show config commit(?: (?:status|statistics))?$",
    description: "Show the history of committed configurations, including when it was done and by whom",
  },
  {
    regexp:
      "^show config running(?: (?:all|control(?: (?:policy|profile|rule))?|network|pkteng|system))?$",
    description: "Display the current running configuration of the BQN. With all, configuration is not abbreviated. With control, only configured policy part is shown.",
  },
  {
    regexp:
      "^show flow ipother(?: (?:all|state))?(?: detail)?$|^show flow ipother [a-zA-Z0-9.:_-]+(?: [a-zA-Z0-9.:_-]+ [a-zA-Z0-9.:_-]+)?$",
    description:
      "Show information about IP-other flows (IP flows neither TCP nor UDP)",
  },
  {
    regexp:
      "^show flow tcp(?: (?:all|state))?(?: detail)?$|^show flow tcp [a-zA-Z0-9.:_-]+(?: [a-zA-Z0-9.:_-]+ [a-zA-Z0-9.:_-]+ [a-zA-Z0-9.:_-]+)?(?: (?:debug|full|sack|sequence|speed|timers))?$",
    description: "Show information about TCP flows (TCP connections)",
  },
  {
    regexp:
      "^show flow udp(?: (?:all|state))?(?: detail)?$|^show flow udp(?: [a-zA-Z0-9.:_-]+ [a-zA-Z0-9.:_-]+ [a-zA-Z0-9.:_-]+)?(?: (?:debug|full))?$",
    description: "Show information about UDP flows",
  },
  {
    regexp: "^show hardware chassis$",
    description: "Show information about the server model",
  },
  {
    regexp: "^show hardware cpu(?: full)?$",
    description: "Show physical CPU information (model, cores, NUMA)",
  },
  {
    regexp: "^show hardware disk$",
    description: "Show physical disk information (model, driver)",
  },
  {
    regexp: "^show hardware id$",
    description: "Show the server hardware ID used for license validation",
  },
  {
    regexp: "^show hardware memory$",
    description: "Show physical memory information (model, size)",
  },
  {
    regexp: "^show hardware network$",
    description: "Show network interface information (driver, MAC)",
  },
  {
    regexp: "^show hardware pci(?: full)?$",
    description:
      "Show information about PCI buses (addresses, devices connected)",
  },
  {
    regexp:
      "^show interface(?: detail)?$",
    description: "List of network interfaces (name, MAC, if state up, if with link)",
  },
  {
    regexp:
      "^show interface [a-zA-Z0-9.:_-]+$",
    description: "Show information about a network interfaces (MAC, negotiated speed, MTU)",
  },
  {
    regexp: "^show interface [a-zA-Z0-9.:_-]+ device$",
    description: "Show network interface driver and model",
  },
  {
    regexp: "^show interface pkteng bandwidth(?: \\d{1,4})?$",
    description: "Show bandwidth per network interface. Useful to detect when interfaces have no traffic, or low traffic or inverse traffic. It allows to identify the wire with no traffic or inverse traffic",
  },
  {
    regexp: "^show interface bta statistics(?: detail)?$",
    description: "Show TCPO statistics per network interface",
  },
  {
    regexp: "^show interface firewall$",
    description:
      "Show white list of source IP addresses allowed to access the BQN management interface. No restriction if empty",
  },
  {
    regexp: "^show interface management(?: detail)?$",
    description: "Show the management network interface. With detail, returns the IP address, VLAN tag, default gateway and DNS server",
  },
  {
    regexp: "^show interface pkteng tx-error-detect$",
    description:
      "Show the detection of transmission errors in network interfaces",
  },
  {
    regexp: "^show ip address$",
    description: "Show the existing BQN server IP addresses and their attributes (management and loopback address)",
  },
  {
    regexp: "^show ip arp$",
    description: "Show the ARP table entries",
  },
  {
    regexp: "^show ip route$",
    description: "Show the existing IP routing table",
  },
  {
    regexp: "^show license$",
    description: "Show a list of all the defined licenses",
  },
  {
    regexp: "^show logging feature$",
    description:
      "Show information about the system logger features used by the BQN software",
  },
  {
    regexp: "^show pkteng affinity$",
    description: "Show the CPU affinities of PKTENG IO processes and workers. Indicates the cores dedicated to traffic processing and which ones are used to talk to the network interfaces (IO) and which ones to process the traffic (workers)",
  },
  {
    regexp: "^show pkteng parameters$",
    description: "Show the properties configured in the packet engine",
  },
  {
    regexp: "^show pkteng sdr$",
    description:
      "Show the number of SDR records generated per pkteng worker process",
  },
  {
    regexp: "^show pkteng speed (?:acceleration|optimized|tracked)(?: full)?$",
    description: "Show metrics of TCP acceleration",
  },
  {
    regexp: "^show pkteng statistics(?: extended)?(?: detail)?$",
    description: "Show the packet and byte counters of PKTENG per server. If detail, per pkteng worker instance",
  },
  {
    regexp: "^show pkteng status$",
    description: "Show the status of the PKTENG service (if processes and interfaces are OK)",
  },
  {
    regexp: "^show pkteng udr$",
    description: "Show information about the number of UDRs generated",
  },
  {
    regexp: "^show pkteng trace(?: detail)?$",
    description: "Show if PKTENG tracing is enabled",
  },
  {
    regexp: "^show pkteng wire$",
    description:
      "Lists the wires (network interface pairs) defined in the BQN",
  },
  {
    regexp: "^show policy flow$",
    description: "List of configured flow policies",
  },
  {
    regexp: "^show policy monitor$",
    description: "List of configured monitor policies",
  },
  {
    regexp: "^show policy rate$",
    description: "List of rate policies, configured and dynamic",
  },
  {
    regexp: "^show process all$",
    description: "Show a list of all the BQN processes. Indicates if running, since when and if restarts occurred",
  },
  {
    regexp: "^show profile(?: [a-zA-Z0-9.:_-]+)?$",
    description: "List of the defined traffic profiles",
  },
  {
    regexp: "^show remctr status$",
    description: "Shows the status of the session with the BQNMGR process (license manager)",
  },
  {
    regexp: "^show rule$",
    description: "List of policy rules defined in the BQN configuration",
  },
  {
    regexp: "^show rule error$",
    description:
      "Lists errors in current set of rules, in particular, rule conflicts",
  },
  {
    regexp: "^show subscriber all full$",
    description:
      "List of active subscribers with their QoE metrics. Includes uplink/downlink volumes (useful to detect asymmetric traffic), latencies and losses",
  },
  {
    regexp: "^show subscriber [a-zA-Z0-9.:_-]+(?: full)?$",
    description:
      "Information about the subscriber identified by the given ip-address",
  },
  {
    regexp: "^show subscriber dos syn$",
    description: "Active DoS SYN attacks",
  },
  {
    regexp: "^show subscriber dos volume$",
    description: "Active DoS volume attacks",
  },
  {
    regexp:
      "^show statistics cpu all lines \\d{1,4}$",
    description: "CPU usage over time, per CPU core",
  },
  {
    regexp: "^show statistics dos$",
    description: "DoS attacks over time",
  },
  {
    regexp:
      "^show statistics interface speed(?: (?:icmp|tcp|udp))?(?: [a-zA-Z0-9.:_-]+)?(?: lines \\d{1,4})?$",
    description: "Traffic speed over time per network interface",
  },
  {
    regexp: "^show statistics latency(?: full)?(?: lines \\d{1,4})?$",
    description:
      "Access latency over time",
  },
  {
    regexp: "^show statistics memory(?: lines \\d{1,4})?$",
    description: "Memory usage over time",
  },
  {
    regexp: "^show statistics policy flow(?: speed)?(?: lines \\d{1,4})?$",
    description:
      "Traffic volume per flow policy (or speeds if speed flag present)",
  },
  {
    regexp: "^show statistics policy monitor(?: speed)?(?: lines \\d{1,4})?$",
    description:
      "Traffic volume per monitor policy (or speeds if speed flag present)",
  },
  {
    regexp: "^show statistics policy rate(?: speed)?(?: lines \\d{1,4})?$",
    description:
      "Show traffic volume per rate policy (or speeds if speed flag present)",
  },
  {
    regexp:
      "^show statistics speed acceleration (?:downlink|uplink) (?:rtta-small|rtta-large)(?: lines \\d{1,4})?$",
    description:
      "TCP acceleration over time as percentage of speed increase",
  },
  {
    regexp:
      "^show statistics speed optimized (?:downlink|uplink) (?:rtta-small|rtta-large)(?: lines \\d{1,4})?$",
    description: "Average speed of accelerated TCP flows over time",
  },
  {
    regexp:
      "^show statistics speed tracked (?:downlink|uplink) (?:rtta-small|rtta-large)(?: lines \\d{1,4})?$",
    description:
      "Average speed of not accelerated TCP flows over time",
  },
  {
    regexp: "^show system alarms$",
    description: "Show the list of system alarms and their status",
  },
  {
    regexp: "^show system bqn id$",
    description: "Show the server identifier used for cluster management",
  },
  {
    regexp: "^show system cpu(?: level)?$",
    description: "Show system CPU usage",
  },
  {
    regexp: "^show system date full$",
    description: "Show the system time, date and time zone",
  },
  {
    regexp: "^show system filesystem(?: full)?$",
    description: "Show file system partitions and usage",
  },
  {
    regexp: "^show system functionality$",
    description:
      "Show a list of functionalities and whether they are enabled or disabled",
  },
  {
    regexp: "^show system hostname$",
    description: "Show the BQN server hostname",
  },
  {
    regexp: "^show system log audit(?: lines \\d{1,4})?(?: bqn-id \\d{1,3})?$",
    description: "Show audit log messages",
  },
  {
    regexp: "^show system log kernel(?: lines \\d{1,4})?(?: bqn-id \\d{1,3})?$",
    description: "Show kernel ring buffer messages",
  },
  {
    regexp: "^show system log messages(?: lines \\d{1,4})?(?: bqn-id \\d{1,3})?$",
    description: "Show system messages",
  },
  {
    regexp: "^show api event log(?: lines \\d{1,4})?(?: bqn-id \\d{1,3})?$",
    description: "Show API event log",
  },
  {
    regexp: "^show system memory(?: full)?$",
    description: "Show RAM memory usage information",
  },
  {
    regexp: "^show system ntp$",
    description: "Show the status of the configured NTP peers/servers",
  },
  {
    regexp: "^show system process top$",
    description: "Show the operating system CPU usage",
  },
  {
    regexp: "^show system sensors$",
    description:
      "Show system sensors information, which currently includes the temperature of the different sensors inside the system, such as the CPU core",
  },
  {
    regexp: "^show system software(?: full)?$",
    description: "Show the BQN packages (BPKG) installed",
  },
  {
    regexp: "^show system status$",
    description: "Show the global status of the BQN",
  },
  {
    regexp: "^show system users(?: [a-zA-Z0-9.:_-]+)?$",
    description:
      "Show information about all the users available in the system",
  },
  {
    regexp: "^show api billing status detail$",
    description: "Show the sync status between the BQN and a billing system",
  },
  {
    regexp: "^net ping [a-zA-Z0-9.:_-]+ count 1$",
    description: "Ping utility",
  },
];
